module.exports = __webpack_public_path__ + "media/scholarship_winners/gwenn-g-fdad784b.png";